import { api } from ".";

const basePath = "/contract";

export const createContract = async ({
  name,
  monthlyHours,
  endDate,
  startDate,
}: any) => {
  try {
    const res = await api.post(`${basePath}`, {
      name,
      monthlyHours,
      endDate,
      startDate,
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const updateContractById = async ({ id, updates }: any) => {
  try {
    const res = await api.put(`${basePath}`, {
      _id: id,
      ...updates,
    });
    return res;
  } catch (error) {
    console.error("Error updating user:", error);
    return error;
  }
};

export const getContractList = async (params: Record<string, any> = {}) => {
  try {
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined)
    );
    const res = await api.get(`${basePath}/list`, { params: filteredParams });
    return res;
  } catch (error) {
    return error;
  }
};

export const deleteContract = async ({ id }: { id: string }) => {
  try {
    const res = await api.delete(`${basePath}`, {
      data: { _id: id },
    });
    return res;
  } catch (error) {
    return error;
  }
};
export const getContractSelectData = async () => {
  try {
    const res = await api.get(`${basePath}/select-data`);
    return res;
  } catch (error) {
    return error;
  }
};

export const getContractById = async ({ id }: any) => {
  try {
    const res = await api.get(`${basePath}`, { params: { _id: id } });
    return res;
  } catch (error) {
    return error;
  }
};